import { getRequest, postRequest, deleteRequest } from './rest'
import { ALL_ORGS_SELECTED, API_BLE_DEVICE_TYPES } from 'lib/constants'
import { KnownBluetoothDevice } from 'lib/types'

const orgHeader = (orgId: string) => (orgId === ALL_ORGS_SELECTED ? {} : { org_id: orgId })

const normalize = (raw: any): KnownBluetoothDevice => ({
  id: String(raw?.id ?? ''),
  orgId: raw?.orgId ?? raw?.org_id ?? '',
  name: raw?.name ?? '',
  createdAt: raw?.insertedAt ?? raw?.createdAt,
  updatedAt: raw?.updatedAt,
})

export const getKnownBluetoothDevices = async (orgId: string): Promise<KnownBluetoothDevice[]> => {
  const res = await getRequest({
    endpoint: API_BLE_DEVICE_TYPES,
    header: orgHeader(orgId),
  })
  const list = res?.data?.data ?? []
  return list.map(normalize)
}

export const addKnownBluetoothDevice = async (
  orgId: string,
  payload: { name: string },
): Promise<KnownBluetoothDevice> => {
  const res = await postRequest({
    endpoint: API_BLE_DEVICE_TYPES,
    header: orgHeader(orgId),
    data: { name: payload.name, orgId },
  })
  return normalize(res?.data?.data ?? res?.data)
}

export const removeKnownBluetoothDevice = async (orgId: string, id: string): Promise<void> => {
  await deleteRequest({
    endpoint: `${API_BLE_DEVICE_TYPES}/${id}`,
    header: orgHeader(orgId),
  })
}
